var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ErrorPageIndex"},[_vm._v(" 您还没有学科哦，请赶快到\"个人中心\"进行任教吧 : ) ")])}
var staticRenderFns = []

export { render, staticRenderFns }